import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import { withStyles } from '@material-ui/core/styles/index';
import red from '@material-ui/core/colors/red';
import Transition from './Transition';

const styles = (theme) => ({
	dialogPaper: {
		overflow: 'scroll',
		width: '60%',
		maxWidth: '90%',
	},
	intro: {
		paddingBottom: 10,
	},
	warningItem: {
		borderLeft: `3px solid #f9a825`,
		padding: '5px 10px',
		marginBottom: 8,
	},
	warningLabel: {
		fontWeight: 600,
	},
	completedWarning: {
		border: `1px solid ${red[500]}`,
		color: red[700],
		fontWeight: 600,
		padding: 10,
		marginTop: 10,
	},
	question: {
		padding: '20px 20px 10px 20px',
		fontWeight: 600,
		fontSize: 16,
		textAlign: 'right',
	},
	actions: {
		padding: 10,
	},
	warningButton: {
		borderRadius: 100,
		color: theme.palette.getContrastText(red[500]),
		backgroundColor: red[500],
		'&:hover': {
			backgroundColor: red[700],
		},
	},
});

/**
 * Shown when a person saves triage corrections while the automated matcher is still
 * reporting problems. Lists exactly what they are overriding so nothing lands on the
 * wrong rack transfer / invoice by accident.
 */
class ConfirmTriageOverrideSave extends PureComponent {
	handleClose = () => {
		this.props.onClose();
	};

	handleConfirm = () => {
		this.props.onClose();
		this.props.onConfirm();
	};

	render() {
		const { classes, open, warnings, hasCompletedTarget, targetLabel } = this.props;

		return (
			<Dialog
				maxWidth="sm"
				open={open}
				TransitionComponent={Transition}
				onClose={this.handleClose}
				classes={{
					paper: classes.dialogPaper,
				}}
			>
				<DialogTitle>Save With Match Warnings?</DialogTitle>
				<DialogContent>
					<div className={classes.intro}>
						The automated matcher is not fully satisfied. Saving will apply your corrections to{' '}
						{targetLabel} anyway. You are overriding:
					</div>

					{warnings.map((warning, i) => {
						return (
							<div className={classes.warningItem} key={`warning_${i}`}>
								<span className={classes.warningLabel}>{warning.label} : </span>
								{warning.message}
							</div>
						);
					})}

					{hasCompletedTarget && (
						<div className={classes.completedWarning}>
							The matched {targetLabel} is no longer pending (see the status above for whether it
							was completed or invalidated). Saving will modify it anyway. Double check these
							documents are not duplicates before continuing.
						</div>
					)}
				</DialogContent>

				<div className={classes.question}>Save your corrections anyway?</div>

				<DialogActions>
					<div className={classes.actions}>
						<Button onClick={this.handleClose}>Close</Button>
						<Button
							variant="contained"
							onClick={this.handleConfirm}
							className={classes.warningButton}
						>
							Yes, save anyway
						</Button>
					</div>
				</DialogActions>
			</Dialog>
		);
	}
}

ConfirmTriageOverrideSave.propTypes = {
	open: PropTypes.bool,
	onClose: PropTypes.func.isRequired,
	onConfirm: PropTypes.func.isRequired,
	warnings: PropTypes.array.isRequired,
	hasCompletedTarget: PropTypes.bool,
	targetLabel: PropTypes.string.isRequired,

	classes: PropTypes.object.isRequired,
};

export default _.flow([withStyles(styles), withMobileDialog()])(ConfirmTriageOverrideSave);
